export const LOGIN_LOADING = "auth/login/loading"
export const LOGIN_SUCCESS = "auth/login/success"
export const LOGIN_ERROR = "auth/login/error"
export const SIGNUP_LOADING = "auth/signup/loading"
export const SIGNUP_SUCCESS = "auth/signup/success"
export const SIGNUP_ERROR = "auth/signup/error"
export const LOGOUT = "auth/login"